import useEmpresasList from "./useEmpresasList";
import useEmpresaForm from "./useEmpresaForm";

export default function useEmpresasLogic() {
  const list = useEmpresasList();

  const form = useEmpresaForm({
    onCreated: (nueva) => list.upsertEmpresa(nueva),
    onUpdated: (actualizada) => {
      list.upsertEmpresa(actualizada);
      if (list.seleccionado?.id === actualizada.id) list.setSeleccionado(actualizada);
    },
    onDeleted: (eliminada) => {
      list.removeEmpresa(eliminada.id);
      if (list.seleccionado?.id === eliminada.id) list.setSeleccionado(null);
    },
  });

  return {
    ...list,
    form,
  };
}

